// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__j6wDk","checkmark":"Checkbox_checkmark__HT3bm"};